








import { Component, Prop, Vue } from 'vue-property-decorator';

import EmbedGameWrapper from '@/components/common/EmbedGameWrapper.vue';
import EmbedGameNotSupported from '@/components/common/EmbedGameNotSupported.vue';

import { IS_MOBILE } from '@/helpers/browser';

@Component({
  components: {
    EmbedGameWrapper,
    EmbedGameNotSupported,
  },
})
export default class EmbedGame extends Vue {
  @Prop({ type: Boolean })
  readonly desktopOnly!: boolean;

  mql = window.matchMedia('(min-width: 768px)');

  frameShown = !this.desktopOnly;

  beforeMount() {
    this.frameShown = this.checkShowFrame();

    this.mql.addEventListener('change', this.handleMQLChange);
  }

  beforeDestroy() {
    this.mql.removeEventListener('change', this.handleMQLChange);
  }

  handleMQLChange(event: MediaQueryListEvent) {
    this.frameShown = this.checkShowFrame(event);
  }

  checkShowFrame(event?: MediaQueryListEvent): boolean {
    const matches = event ? event.matches : this.mql.matches;

    if (this.frameShown || !this.desktopOnly) {
      return true;
    }

    return !IS_MOBILE && matches;
  }
}
